import Audio from './Audio'
import Video from './Video'
import Ticket from './Ticket'
import Magazine from './Magazine'

const Component = ({ type, ...props }) => {
  switch (type) {
    case 'audio':
      return <Audio {...props} />
    case 'video':
      return <Video {...props} />
    case 'magazine':
      return <Magazine {...props} />
    case 'ticket':
      return <Ticket {...props} />
    default:
      return null
  }
}

export default Component
